import LandingPage from "@components/landing/pages/LandingPage";
import RestaurantOfferPage from "@components/offer/pages/RestaurantOfferPage";
import UserSettingsRoute from "@components/user-settings/shared/Route";
import AdministrationRoute from "@components/administration/shared/Route";
import Layout from "@layout/Layout";
import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const RegistrationPage = lazy(() => import("@components/membership/pages/RegistrationPage"));
const PasswordRecoveryPage = lazy(() => import("@components/membership/pages/PasswordRecoveryPage"));
const AboutUsPage = lazy(() => import("@components/information/about-us/pages/AboutUsPage"))
const OurOfferPage = lazy(() => import("@components/information/our-offer/pages/OurOfferPage"))

let Routes: RouteObject[] = [
    {
        // path: "/",
        // element: <LandingPage />,

        element: <Layout />,
        children: [
            {
                path: "/",
                element: <LandingPage />,
            },
            {
                path: "/restaurant/:restaurantId/offer",
                element: <RestaurantOfferPage />,
            },
            {
                path: "/food-categories/:restaurantId",
                element: <RestaurantOfferPage />,
            },
            {
                path: "/password-recovery",
                element: <PasswordRecoveryPage />,
            },
            {
                path: "/registration",
                element: <RegistrationPage />,
            },
            {
                path: "/about-us",
                element: <AboutUsPage />,
            },
            {
                path: "/our-offer",
                element: <OurOfferPage />,
            }
        ],
    },
    UserSettingsRoute,
    AdministrationRoute
];

export default Routes;
